/**
 * @flow
 * @relayHash 3243e9ea36c9e3c06db16b502dfac748
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCustomerInput = {|
  id: string
|};
export type DeleteCustomerMutationVariables = {|
  input: DeleteCustomerInput
|};
export type DeleteCustomerMutationResponse = {|
  +deleteCustomer: {|
    +deletedId: string
  |}
|};
export type DeleteCustomerMutation = {|
  variables: DeleteCustomerMutationVariables,
  response: DeleteCustomerMutationResponse,
|};
*/


/*
mutation DeleteCustomerMutation(
  $input: DeleteCustomerInput!
) {
  deleteCustomer(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCustomerInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCustomer",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCustomerPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteCustomerMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteCustomerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteCustomerMutation",
    "id": null,
    "text": "mutation DeleteCustomerMutation(\n  $input: DeleteCustomerInput!\n) {\n  deleteCustomer(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c0c064b64973ad38e91709d54fb679c3';
module.exports = node;
